var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSmallDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.34253 26.1577C9.3425 12.9489 21.6107 3.33569 36.1256 3.33569C53.8864 3.33569 68.2848 17.7341 68.2848 35.4949C68.2848 53.2557 53.8864 67.6541 36.1256 67.6541C21.8439 67.6541 9.73512 58.3441 5.54078 45.4618",
    stroke: "url(#paint0_linear_11105_6491)",
    strokeWidth: 4.65579,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5375 29.9284C47.8222 29.2559 46.8737 28.9177 45.6959 28.9177C44.5181 28.9177 43.5074 29.2559 42.7921 29.9284C42.0769 30.6009 41.7192 31.5066 41.7192 32.6456V43.8564C41.7192 46.9429 40.2615 49.9866 36.9029 50.3986C32.8952 50.8884 30.7844 47.4132 30.7844 43.8564V32.6456C30.7844 31.5066 30.4268 30.6048 29.7115 29.9284C28.9963 29.2559 28.0284 28.9177 26.8078 28.9177C25.5872 28.9177 24.6814 29.2559 23.9662 29.9284C23.2509 30.6009 22.8933 31.5066 22.8933 32.6456V44.1907C22.8933 52.6805 28.6736 57.6989 36.2304 57.7222C36.2382 57.7222 36.246 57.7222 36.2538 57.7222C36.2615 57.7222 36.2693 57.7222 36.2771 57.7222C43.8339 57.7028 49.6142 52.6805 49.6142 44.1907V32.6456C49.6142 31.5066 49.2566 30.6048 48.5414 29.9284H48.5375Z",
    fill: "#4FC0CF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7845 24.7234C28.8133 24.7234 30.458 23.0787 30.458 21.0499C30.458 19.0211 28.8133 17.3765 26.7845 17.3765C24.7557 17.3765 23.1111 19.0211 23.1111 21.0499C23.1111 23.0787 24.7557 24.7234 26.7845 24.7234Z",
    fill: "#4FC0CF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3888 24.6223C47.4176 24.6223 49.0622 22.9776 49.0622 20.9488C49.0622 18.92 47.4176 17.2754 45.3888 17.2754C43.36 17.2754 41.7153 18.92 41.7153 20.9488C41.7153 22.9776 43.36 24.6223 45.3888 24.6223Z",
    fill: "#4FC0CF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11105_6491",
    x1: 36.8137,
    y1: 1.00335,
    x2: 36.8137,
    y2: 69.9864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ED957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#6ACE87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#51C1C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#3B9EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#1E6E95"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmallDark);
export default __webpack_public_path__ + "static/media/logoSmallDark.ccaaca1e413c69b7d3647854a360f2c5.svg";
export { ForwardRef as ReactComponent };